import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import {DatabaseComponent} from './database.component';
import {DbTableDefinitionModule} from '../dbTableDefinition/dbTableDefinition.module';
import {GenericModalModule} from '../modal/generic-modal.module';
@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        DbTableDefinitionModule,
        GenericModalModule
    ],
    declarations: [
        DatabaseComponent
    ],
    exports: [
        DatabaseComponent
    ],
    providers: []
})

export class DatabaseModule {
}
